import React from 'react';
import { CircularProgress } from 'lib/@mui';

import CenterContainer from '../CenterContainer';

import styles from './styles.module.scss';

export const FullScreenLoader = () => (
    <CenterContainer className={styles.box}>
        <CircularProgress color="inherit" />
    </CenterContainer>
);
